import { motion } from "framer-motion";
import { Card, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
// import { getSocialURLs } from "@/lib/socials";
import { ExternalLink, Heart } from "lucide-react";
import { cn } from "@/lib/utils";
import { Show } from "@/components/atoms/show";
import { getCollectionFormStyles } from "../../utils/extract-review-form-styles";
// import { getImage } from "../../utils/helpers";
import { CollectionFormScreenProps } from "../../types";
import { getImage } from "../../utils/helpers";
// import { CollectionFormTypes } from "../../utils/schema";

export const ClosingScreen = ({ data }: CollectionFormScreenProps) => {
  // const reviewCollectionFormUrl = `${process.env.NEXT_PUBLIC_SHARE_URL}/f/${data.id}`;
  // const shareUrls = getSocialURLs(reviewCollectionFormUrl);
  const styles = getCollectionFormStyles(data);

  // const handleShare = (platform: keyof typeof shareUrls) => {
  //   window.open(shareUrls[platform], "_blank");
  // };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <Card
        className={cn(
          styles.cardPadding,
          styles.cardSpacing,
          "testify-max-w-xl testify-w-full",
        )}
        style={{
          backgroundColor: styles["secondaryColor"],
          color: styles["secondaryTextColor"],
        }}
      >
        {/* Success Icon
        <div className="testify-bg-primary/10 testify-py-8 testify-flex testify-flex-col testify-items-center">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 20,
              delay: 0.1,
            }}
            className="testify-w-16 testify-h-16 testify-rounded-full testify-bg-primary/20 testify-flex testify-items-center testify-justify-center testify-mb-4"
          >
            <ThumbsUp className="testify-h-8 testify-w-8 testify-text-primary" />
          </motion.div>

         
        </div> */}

        <CardTitle className="testify-text-2xl sm:testify-text-3xl md:testify-text-4xl testify-font-bold testify-text-center">
          {data.thankYouPage.title}
        </CardTitle>
        <div className="testify-space-y-6">
          {/* Thank You Image */}
          <Show when={data.thankYouPage.allowImage}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="testify-relative testify-rounded-lg testify-overflow-hidden"
            >
              <img
                src={getImage(data.thankYouPage.image)}
                className="testify-w-full testify-aspect-video testify-object-cover testify-flex-shrink-0"
                alt="Thank you"
              />
            </motion.div>
          </Show>

          {/* Thank You Message */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="testify-text-center testify-space-y-4"
          >
            <CardDescription
              className="testify-text-base sm:testify-text-lg md:testify-text-xl testify-leading-relaxed"
              dangerouslySetInnerHTML={{ __html: data.thankYouPage.message }}
            />
          </motion.div>

          {/* Social Sharing */}
          {/* <Show when={data.thankYouPage.allSocialSharing}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="testify-space-y-4"
            >
              <div className="testify-text-center">
                <div className="testify-inline-flex testify-items-center testify-gap-2 testify-text-sm testify-text-muted-foreground">
                  <Share2 className="testify-h-4 testify-w-4" />
                  Share your testimonial
                </div>
              </div>

              <div className="testify-flex testify-justify-center testify-gap-3">
                {(
                  Object.entries(data.thankYouPage.shareOn) as [
                    keyof CollectionFormTypes["thankYouPage"]["shareOn"],
                    boolean,
                  ][]
                ).map(([platform, show]) => {
                  if (!show) return null;

                  const Social = socials.find(
                    ({ label }) => label === platform.toLowerCase(),
                  );

                  if (!Social) return null;

                  return (
                    <Button
                      key={platform}
                      variant="outline"
                      size="lg"
                      className="testify-flex-1 testify-max-w-[120px]"
                      onClick={() => handleShare(platform as "facebook")}
                    >
                      <Social.icon className="testify-h-5 testify-w-5 testify-mr-2" />
                      {platform}
                    </Button>
                  );
                })}
              </div>
            </motion.div>
          </Show> */}

          {/* Redirect Link if provided */}
          {data.thankYouPage.redirect && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="testify-pt-4"
            >
              <Button
                variant="secondary"
                className="testify-w-full"
                onClick={() =>
                  (window.location.href = data.thankYouPage.redirect)
                }
              >
                <span>Return to Website</span>
                <ExternalLink className="testify-h-4 testify-w-4 testify-ml-2" />
              </Button>
            </motion.div>
          )}
        </div>

        {/* Optional Footer */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="testify-border-t testify-p-4 testify-text-center"
        >
          <span className="testify-text-sm sm:testify-text-base testify-text-muted-foreground testify-flex testify-items-center testify-justify-center testify-gap-1">
            Thanks for sharing your experience
            <Heart className="testify-h-3 testify-w-3 testify-text-red-500 testify-fill-red-500" />
          </span>
        </motion.div>
      </Card>
    </motion.div>
  );
};
